import { styles } from '../../../style';
import { Card } from '../../common/Card';
import { Link } from '../../common/Link';

import BillingInfo from './billing-info/BillingInfo';

const BillingDashboard: React.FC = () => {
  return (
    <Card className="card billing">
      <div className="header">
        <p style={{ ...styles.mediumText, fontWeight: 700 }}>Billing</p>
        <Link to="/billing" variant="internal">
          View more
        </Link>
      </div>
      <BillingInfo showGoToBillingLinks={true} />
    </Card>
  );
};
export default BillingDashboard;
